/**
 * Reads the duration (in seconds) of an audio or video file in the browser,
 * without uploading it. Resolves to `null` when the browser can't decode the
 * file's metadata, so callers can let the server validate instead.
 */
export const getMediaDuration = async (file: File): Promise<number | null> =>
	await new Promise(resolve => {
		if (typeof document === 'undefined') {
			resolve(null);
			return;
		}

		const isAudio = file.type.startsWith('audio/');
		const media = document.createElement(isAudio ? 'audio' : 'video');
		const objectUrl = URL.createObjectURL(file);

		const finish = (duration: number | null) => {
			media.removeAttribute('src');
			media.load();
			URL.revokeObjectURL(objectUrl);
			resolve(duration);
		};

		media.preload = 'metadata';
		media.onloadedmetadata = () => {
			finish(Number.isFinite(media.duration) ? media.duration : null);
		};
		media.onerror = () => finish(null);
		media.src = objectUrl;
	});
